import { render, staticRenderFns } from "./Kuponlar.vue?vue&type=template&id=1cc14038&scoped=true"
import script from "./Kuponlar.vue?vue&type=script&lang=js"
export * from "./Kuponlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc14038",
  null
  
)

export default component.exports